<template>
  <div class="header">
    <!-- pc端 -->
    <div class="navbox">
      <div class="logo">
        <div class="container">
          <div class="left">
            <img src="/static/index/logo.png" alt="" />
          </div>
          <div class="right">
            <img src="/static/index/icon.png" alt="" />
            <div class="phone">
              <p>15811205095</p>
              <span>客服在线时间：8:00-22:00</span>
            </div>
          </div>
        </div>
      </div>
      <div class="nav">
        <div class="container">
          <ul :class="ishidenav ? 'navbox' : ''">
            <li
              v-for="(item, index) in navs"
              :class="item.active ? 'on' : ''"
              :key="index"
            >
              <router-link :to="item.href">{{ item.name }}</router-link>
            </li>
          </ul>
          <!-- <el-menu
            :default-active="activeIndex2"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            text-color="#fff"
            :router="true"
            popper-class="menus-menu"
          >
            <el-menu-item
              :index="item.href"
              v-for="(item, index) in navs"
              :class="item.active ? 'on' : ''"
              :key="index"
              >{{ item.name }}</el-menu-item
            >
            <el-submenu index="/literature/content">
              <template slot="title">我的工作台</template>
              <el-menu-item index="/literature/content?id=134">选项1</el-menu-item>
              <el-menu-item index="2-2">选项2</el-menu-item>
              <el-menu-item index="2-3">选项3</el-menu-item>
              <el-submenu index="2-4">
                <template slot="title">选项4</template>
                <el-menu-item index="2-4-1">选项1</el-menu-item>
                <el-menu-item index="2-4-2">选项2</el-menu-item>
                <el-menu-item index="2-4-3">选项3</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu> -->
          <div class="login" v-if="!isLoginType && !token">
            <p @click="isLoginFlag">登录</p>
            <p @click="isResFlag">注册</p>
          </div>
          <div class="loginto" v-else>
            <router-link :to="$Router.order.path">
              <div class="title">客户中心</div>
            </router-link>
            <div class="box">
              <ul>
                <li @click="logout">退出登录</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="h5navbox">
      <div class="container">
        <div class="logo">
          <img src="/static/index/logo.png" alt="" />
        </div>
        <div class="m-meun">
          <div class="icon" @click="onnavbox">
            <img src="/static/index/img-m-1.jpg" alt="" />
          </div>
          <div :class="['nav-box', ishnav ? 'on' : '']">
            <ul :class="ishidenav ? 'navbox' : ''">
              <li
                v-for="(item, index) in navs"
                :class="item.active ? 'on' : ''"
                :key="index"
              >
                <router-link :to="item.href">{{ item.name }}</router-link>
              </li>
            </ul>
            <div class="loginbox">
              <div class="login" v-if="!isLoginType && !token">
                <p @click="isLoginFlag">登录</p>
                <p @click="isResFlag">注册</p>
              </div>
              <div class="loginto" v-else>
                <div class="item">
                  <router-link :to="$Router.order.path">
                    <div class="title">客户中心</div>
                  </router-link>
                </div>
                <div class="item" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login v-if="ishidefun"></login>
  </div>
</template>

<script>
import login from '@/components/login/login.vue'
import service from './header'

export default {
  name: 'headers',
  data () {
    return {
      ishnav: false,
      ishidenav: false,
      userinfo: {},
      islogin: false,
      logo: '华科鉴联基因科技（北京）有限公司',
      nowDate: '2021/2/2 01:34:59 星期五', // 当前日期
      activeIndex2: this.$route.fullPath,
      input: '',
      navs: [
        {
          id: 1,
          active: this.$route.name === this.$Router.index.name,
          name: '首页',
          href: this.$Router.index.path
        },
        {
          id: 2,
          active: this.$route.name === this.$Router.about.name,
          name: '关于我们',
          href: this.$Router.about.path
        },
        {
          id: 3,
          active:
            this.$route.name === this.$Router.services.name ||
            this.$route.name === this.$Router.serviceslist.name ||
            this.$route.name === this.$Router.servicescontent.name,
          name: '服务项目',
          href: this.$Router.services.path
        },
        {
          id: 4,
          active:
            this.$route.name === this.$Router.news.name ||
            this.$route.name === this.$Router.newscontent.name,
          name: '新闻及案例分享',
          href: this.$Router.news.path
        },
        {
          id: 5,
          active:
            this.$route.name === this.$Router.training.name ||
            this.$route.name === this.$Router.traininglist.name ||
            this.$route.name === this.$Router.trainingcontent.name,
          name: '技术培训',
          href: this.$Router.training.path
        },
        {
          id: 6,
          active: this.$route.name === this.$Router.Partners.name,
          name: '合作伙伴',
          href: this.$Router.Partners.path
        },
        {
          id: 7,
          active: this.$route.name === this.$Router.database.name,
          name: '细胞系STR数据库在线比对',
          href: this.$Router.database.path
        },
        {
          id: 8,
          active: this.$route.name === this.$Router.literature.name,
          name: '细胞鉴定相关文献下载区',
          href: this.$Router.literature.path
        }
      ]
    }
  },
  components: {
    login
  },
  computed: {
    isLoginType () {
      return this.$store.state.login.isLoginType
    },
    ishidefun () {
      return this.$store.state.login.ishidefun
    },
    token () {
      return localStorage.getItem('token')
    },
    userid () {
      return this.$store.state.user.userInfo.id
    }
  },
  watch: {
    ishidefun () {
      if (this.ishidefun) {
        this.$common.scrollstop()
      } else {
        this.$common.scrollmove()
      }
    }
  },
  methods: {
    onnavbox () {
      this.ishnav = !this.ishnav
    },
    isLoginFlag () {
      this.$store.dispatch('set_isLogin', true)
      this.$store.dispatch('set_ishidefun', true)
    },
    isResFlag () {
      this.$store.dispatch('set_isLogin', false)
      this.$store.dispatch('set_isQrCode', true)
      this.$store.dispatch('set_isReset', true)
      this.$store.dispatch('set_ishidefun', true)
    },
    logout () {
      localStorage.removeItem('token')
      this.$router.go()
    },
    currentTime () {
      setInterval(this.formatDate, 500)
    },
    formatDate () {
      var date = new Date()
      var year = date.getFullYear() // 年
      var month = date.getMonth() + 1 // 月
      var day = date.getDate() // 日
      var hour = date.getHours() // 时
      hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
      var minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零
      this.nowDate = `${year}年${month}月${day}日 ${hour}:${minute}`
    },
    handleSelect (key, keyPath) {
      this.activeIndex2 = key
    }
  },
  mounted () {
    this.currentTime()
    console.log(this.$route)
    if (this.token && !this.userid) {
      service.getUserInfo(this)
    }
  },
  // 销毁定时器
  beforeDestroy () {
    if (this.formatDate) {
      clearInterval(this.formatDate)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./header.scss";
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue